import { FC } from 'react'

import PerFlexRow from '../FlexRow'
import { ForecastModalHiringsTable, ForecastModalHiringsFilters } from '.'

export const ForecastModalHiringsContent: FC<unknown> = () => {
  return (
    <PerFlexRow className="fullWidth">
      <ForecastModalHiringsFilters />
      <ForecastModalHiringsTable />
    </PerFlexRow>
  )
}
